import { Terminal, ShieldCheck } from "lucide-react";

const LINKS = ["Product", "Pricing", "Docs", "Sign In"];

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-[#e8e8e4] bg-white">
    <div className="mx-auto max-w-7xl px-6 pb-10 pt-16">
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
        <div>
          <a href="#top" className="flex items-center gap-3">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#2563eb]">
              <Terminal className="h-4 w-4 text-white" strokeWidth={2.5} />
            </span>
            <span className="font-display text-xl font-semibold text-[#0b0f1a]">emergent</span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
            The agentic vibe-coding platform. Speak it, ship it.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-10 gap-y-4">
          {LINKS.map((l) => (
            <a
              key={l}
              data-testid={l === "Product" ? "footer-emergent-link" : undefined}
              href="https://emergent.sh"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-slate-500 transition-colors hover:text-[#2563eb]"
            >
              {l}
            </a>
          ))}
        </nav>
        <div className="flex flex-col gap-3">
          {["SOC2 TYPE II", "ISO 27001"].map((b) => (
            <span
              key={b}
              className="inline-flex items-center gap-2 rounded-full border border-[#e8e8e4] bg-[#f8f8f6] px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500"
            >
              <ShieldCheck className="h-3.5 w-3.5 text-[#10b981]" />
              {b}
            </span>
          ))}
        </div>
      </div>

      <p className="text-watermark font-display mt-16 select-none text-center text-[13vw] font-bold leading-none">
        EMERGENT
      </p>

      <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-[#e8e8e4] pt-6 sm:flex-row">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
          © 2026 emergent.sh — All rights reserved
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">Made for builders, by agents</p>
      </div>
    </div>
  </footer>
);
